import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";
import { ApplyInputTypeInfo, SubscribeInfoData } from "./agent-user-subinfo-get";

// 原始接口
export interface Response {
  actors: Actors[];
  page: number;
  size: number;
  total: number;
};

export interface Actors {
  id: number;
  model_id: string;
  name: string;
  gender: string;
  age_group: string;
  is_hd: boolean;
  is_pro: boolean;
  is_exclusive_pro: boolean;
  is_free_speech: boolean;
  situation: string;
  image_url: string;
  compressed_actor_default_video_url?: string;
  full_actor_default_video_url?: string;
  sort_order: number;
  use_count: number;
  favourite_count: number;
  is_free: string;
  publish_state: string;
  admin_id: number;
  task_id?: string;
  movie_props: string;
  actor_situation?: string;
  accessories?: string;
  emotion: string;
  skin_tone: string;
  created_at: Date;
  updated_at: Date;
  tags?: string[];
  is_favorite: boolean;
  is_my_actor: boolean;
  source?: string;
};

// 请求接口
export interface AgentUserActorsFilterRequest {
  pageSize?: number;
  sid?: number;
  gender?: string;
  name?: string;
}

export class PublicActorTemplateData {
  @Required("id cannot be empty")
  @IsNumber("id must be a number")
  id: number;

  @Required("name cannot be empty")
  @IsString("name must be a string")
  name: string;

  @Required("imageUrl cannot be empty")
  @IsString("imageUrl must be a string")
  imageUrl: string;

  // @Required("modelId cannot be empty")
  @IsString("modelId must be a string")
  modelId: string;

  // @Required("gender cannot be empty")
  @IsString("gender must be a string")
  gender: string;

  // @Required("width cannot be empty")
  @IsNumber("width must be a number")
  width: number;

  // @Required("height cannot be empty")
  @IsNumber("height must be a number")
  height: number;

  // @Required("situation cannot be empty")
  @IsString("situation must be a string")
  situation: string;
}

export class AgentUserActorsFilterData {
  // @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @IsNumber("sid must be a number")
  sid: number;

  @IsArray("actors must be an array")
  actors: PublicActorTemplateData[];
}

const transformAndValidateAgent = (
  response: Response
): AgentUserActorsFilterData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUserActorsFilterData);
  } catch (error) {
    console.error("Agent data validation failed:", error.message);
    throw error;
  }
};

/** 公共数字人模板 */
export const agentUserActorsFilter = async ({
  pageSize,
  sid,
  gender,
  name,
}: AgentUserActorsFilterRequest): Promise<AgentUserActorsFilterData> => {
  const response = await api.post<Response>('/agent/user/actors/filter', {
    page_size: pageSize,
    sid,
    gender: gender ? [gender] : undefined,
    name,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
